import service, { HttpResponseSuccess } from '@/services/service';
import { User } from '@/modules/user/userTypes';

const apiClient = service(`${process.env.REACT_BACKEND_HOST}`);

export interface OnboardingStatusPayload {
	status: 'completed' | 'skipped' | 'pending';
}

export type OnboardingStatusResponse = User;

export const ONBOARDING_STATUS_QUERY_KEY = ['onboardingStatus'];

export const updateOnboardingStatus = (
	payload: OnboardingStatusPayload
): Promise<HttpResponseSuccess<OnboardingStatusResponse>> =>
	apiClient.put('/api/user/onboarding/status', payload);
